import { useEffect, useState } from 'react';
import { onSnapshot } from 'firebase/firestore';

const useFirestoreCount = (targetQuery, enabled = true) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!enabled || !targetQuery) {
      setCount(0);
      return undefined;
    }

    const unsubscribe = onSnapshot(targetQuery, (snapshot) => {
      setCount(snapshot.size);
    });

    return () => unsubscribe();
  }, [enabled, targetQuery]);

  return count;
};

export default useFirestoreCount;
